<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AddressSearch',
})
</script>
<template>
  <AutoComplete :class="bem()" v-model:value="keyword" size="large" @search="debouncedSearch" @select="handleSelect">
    <Input.Search placeholder="请输入关键词进行搜索" enter-button />
    <template #option="item">
      <div :class="bem('option')">
        <span>{{ item.name }}</span>
        <label>{{ item.address }}</label>
      </div>
    </template>
  </AutoComplete>
</template>

<script lang="ts" setup name="AddressSearch">
import { AutoComplete, Input } from 'ant-design-vue'
import { ref } from 'vue'
import { debounce } from 'lodash-es'
import { createNamespace } from '@bd/vue3-utils'
const [_, bem] = createNamespace('TMapAddressSearch')
const keyword = ref()
const emits = defineEmits(['search', 'select'])
const debouncedSearch = debounce((word: string) => {
  emits('search', word)
}, 300)
const handleSelect = (...e) => emits('select', ...e)
</script>
<style lang="less">
.t-map-address-search {
  width: 280px;

  &__option {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    line-height: 20px;

    span {
      font-weight: 500;
    }

    label {
      margin: 0;
      color: @text-color-secondary;
      white-space: wrap;
      word-break: break-all;
    }
  }
}
</style>
